import { trpc } from '@/shared/api/trpc';

// Reporter's own unresolved (open + in_progress) incident count. Drives the
// header badge; kept fresh by invalidation on every incident mutation (no
// polling), mirroring tasks.flaggedCount.
export const useMyUnresolvedCount = () =>
  trpc.incidents.myUnresolvedCount.useQuery();
